import { render, staticRenderFns } from "./IconWarning.vue?vue&type=template&id=f5ee8c74&"
import script from "./IconWarning.vue?vue&type=script&lang=js&"
export * from "./IconWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5ee8c74')) {
      api.createRecord('f5ee8c74', component.options)
    } else {
      api.reload('f5ee8c74', component.options)
    }
    module.hot.accept("./IconWarning.vue?vue&type=template&id=f5ee8c74&", function () {
      api.rerender('f5ee8c74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconWarning.vue"
export default component.exports